'use client';

import { useTranslations } from 'next-intl';
import { useIsomorphicLayoutEffect } from 'react-use';

import { FlipsterLogo } from '@flipster/features/src/shared/logo';
import { Link } from '@flipster/i18n/routing';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { GNBEvent } from '@flipster/utils/segment/events/gnb';

import { GnbAuthActions } from './gnb-auth-actions';
import { GnbList } from './gnb-list';
import { MobileMenu } from './mobile-menu';

const Gnb = () => {
  const t = useTranslations();
  useIsomorphicLayoutEffect(() => {
    document.documentElement.classList.add('gnb');
    return () => document.documentElement.classList.remove('gnb');
  }, []);

  return (
    <>
      <div className={css({ w: '100%', h: 'gnbHeight' })} />
      <nav
        className={hstack({
          zIndex: 'gnb',
          pos: 'fixed',
          top: 0,
          left: 0,
          w: '100%',
          h: 'gnbHeight',
          py: { base: 10, tablet: 12 },
          px: { base: 16, tablet: 24 },
          justify: 'space-between',
          bgColor: 'background.default.level-0',
          smallDesktopDown: { overflow: 'hidden' },
        })}
      >
        <Link
          href='/'
          aria-label={t('Autogen_common.r251126.s_to_home')}
          className={css({ buttonShape: 'inline-icon', mr: 32 })}
          onClick={() => segment.track(GNBEvent.GnbHomeClick)}
        >
          <FlipsterLogo withType css={{ w: { base: 96, tablet: 110 } }} />
        </Link>
        <GnbList />
        <GnbAuthActions />
        <MobileMenu />
      </nav>
    </>
  );
};

export default Gnb;
